import { isDefinedArray } from "et3-type-guards";
import { apiCallGetTBWReasons } from "../../../api/core-api/api-call-get-TBW-reasons";

import getCorePopUpStore from "../../core/core-popup-store";
import getTBWStore from ".";

const getTBWReasonsFromDatabase = async () => {
  const type = getTBWStore().TBWreasonType.get().value;
  const { status, data, code } = await apiCallGetTBWReasons({
    type
  });
  if (status === "OK") {
    getTBWStore().TBWreasons.set(data);
  } else if (isDefinedArray(data)) {
    getCorePopUpStore().showAlertMessage(code);
  }
  return status;
};
export default getTBWReasonsFromDatabase;
